import { Component, Input, OnInit } from '@angular/core';

export interface StepHeaderItem {
  heading: string;
  subText: string;
  stepNumber: number;
  image: string;
}

@Component({
  selector: 'app-step-header',
  templateUrl: './step-header.component.html',
  styleUrls: ['./step-header.component.scss'],
})
export class StepHeaderComponent implements OnInit {
  constructor() {}

  public steps: StepHeaderItem[] = [
    {
      heading: 'Select',
      subText: 'Choose from over 200 digital gift cards.',
      stepNumber: 1,
      image: '/au/giftcards/assets/pointer.svg',
    },
    {
      heading: 'Personalize',
      subText: 'Put a personal touch on your gift card with a message and GIF.',
      stepNumber: 2,
      image: '/au/giftcards/assets/pencil.svg',
    },
    {
      heading: 'Checkout',
      subText: 'Checkout with your Zip account.',
      stepNumber: 3,
      image: '/au/giftcards/assets/checkout.svg',
    },
    {
      heading: 'Receive',
      subText: 'Send quickly via email, or schedule for later.',
      stepNumber: 4,
      image: '/au/giftcards/assets/email.svg',
    },
    {
      heading: 'Redeem',
      subText: 'Redeem for yourself or send to a friend!',
      stepNumber: 5,
      image: '/au/giftcards/assets/gift.svg',
    },
  ];

  ngOnInit() {}
}
